module.exports = __webpack_public_path__ + "static/img/dice_2.05b8261.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lottery/dice/dice_2.png
// module id = ydV0
// module chunks = 23